import {RefObject, useCallback} from 'react';

import {AppsSelectionWithoutContent} from '@web-catalog/types';

import {useOnScreenOnce} from '@web-catalog/hooks';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';
import {getFeaturingAnalyticsType} from '@web-catalog/utils/analytics/useFeaturingAnalytics';

export const useLogOnCompilationShow = ({
  ref,
  selection,
  selectionNumber,
}: {
  ref: RefObject<HTMLElement>;
  selection: AppsSelectionWithoutContent | null | undefined;
  selectionNumber: number;
}) => {
  const getVkId = useGetVkId();
  useOnScreenOnce({
    ref,
    intersectionThreshold: 0.5,
    callback: useCallback(() => {
      logTmrEvent({
        logEvent: 'compilation.show',
        params: {
          compilation_framework_type: 'compilation',
          started_isStub: 0,
          vk_id: getVkId(),
          compilation_id: selection?.id,
          compilation_name: selection?.title?.value,
          compilation_num: selectionNumber,
          compilation_type: getFeaturingAnalyticsType(
            selection?.type,
            selection?.displayType,
          ),
        },
      });
    }, [getVkId, selection, selectionNumber]),
  });
};
